import { Link } from "react-router-dom";
import { site } from "../config/site";

export default function Footer() {
  return (
    <footer className="bg-dark text-white/70">
      <div className="mx-auto max-w-6xl px-4 py-14 grid gap-10 md:grid-cols-3">

        {/* Branding */}
        <div>
          <img
            src="/Gruppierung-TSS-Logo-weiss_transparent.png"
            alt="Team Sempachersee"
            className="h-12 w-auto mb-4"
          />
          <p className="text-sm leading-relaxed">
            Nachwuchsfussball rund um den Sempachersee – sportlich, fair, gemeinschaftlich.
          </p>
        </div>

        {/* Kontakt */}
        <div>
          <p className="text-white font-bold uppercase tracking-wide text-xs mb-4">Kontakt</p>
          <ul className="space-y-1 text-sm">
            <li className="leading-relaxed">
              {site.contact.address.split(', ').map((line, i) => (
                <span key={i} className="block">{line}</span>
              ))}
            </li>
            <li className="pt-1">
              <a href={`tel:${site.contact.phone}`} className="hover:text-white transition-colors">
                {site.contact.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${site.contact.email}`} className="hover:text-white transition-colors">
                {site.contact.email}
              </a>
            </li>
          </ul>
        </div>

        {/* Links */}
        <div>
          <p className="text-white font-bold uppercase tracking-wide text-xs mb-4">Links</p>
          <ul className="space-y-1 text-sm">
            <li><Link to="/news"      className="hover:text-white transition-colors">News</Link></li>
            <li><Link to="/teams"     className="hover:text-white transition-colors">Teams</Link></li>
            <li><Link to="/sponsoren" className="hover:text-white transition-colors">Sponsoren</Link></li>
            <li><Link to="/kontakt"   className="hover:text-white transition-colors">Kontakt</Link></li>
            <li className="pt-2 border-t border-white/10">
              <Link to="/impressum"   className="hover:text-white transition-colors">Impressum</Link>
            </li>
            <li><Link to="/datenschutz" className="hover:text-white transition-colors">Datenschutz</Link></li>
            <li className="pt-2 border-t border-white/10">
              <Link
                to="/admin"
                className="hover:text-white transition-colors flex items-center gap-1.5"
              >
                <svg className="h-3 w-3" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
                </svg>
                Login
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 py-4 text-center text-xs text-white/40">
        © {new Date().getFullYear()} {site.name} — Alle Rechte vorbehalten
      </div>
    </footer>
  );
}
